import axiosRetry from 'axios-retry';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const api = axiosWithHeaders({
	config,
	service: 'userManagement',
	axiosCreateOpts: { timeout: 10_000 }, // This is a critical API call.
});

axiosRetry(api, {
	retries: 5,
	shouldResetTimeout: true,
	retryDelay: (i, e) => axiosRetry.exponentialDelay(i, e, 1_000),
	retryCondition: error => {
		// By default, axios-retry only retries when there is a network error or a 5xx on an idempotent request.
		// This will make sure that a retry is triggered too if the request connection was aborted (usually due to timeout).
		// Cancelling a request using AbortController.signal WON'T trigger a retry. THIS IS INTENDED.
		//
		// Manual cancellation should be handled manually when a component unmounts while a request is pending and if needed,
		// a new request will be triggered MANUALLY by the component. WE SHOULD NOT RETRY ON THIS SCENARIO.
		//
		// shouldResetTimeout MUST be true, otherwise a retry won't happen on timeouts.
		//
		// prettier-ignore
		return (
      axiosRetry.isNetworkOrIdempotentRequestError(error)
      || 'code' in error && error.code === 'ECONNABORTED'
    );
	},
});

export default api;
